module.exports = __webpack_public_path__ + "img/icon_map_51_off_011.6607fff8.png";